// HazardsList/index.js
import { connect } from 'react-redux';
import HazardsList from '../../components/HazardsList';

import { domainType } from '../../constants';
import { documentType } from '../../constants';

import {
  fetchAllHazardsForBranchDispatch,
  fetchAllDocumentsDispatch,
  openEditHazardPanelDispatch,
  openEditHazardDialogDispatch,
  hazardEditClickDispatch,
  openDeleteHazardDialogDispatch,
  submitDeleteHazardRequestDispatch,
  openHazardReviewPanelDispatch,
  openHazardManagementLogPanelDispatch,
  fetchExistingAttachmentsForTheHazardDispatch
} from '../../actions';

function mapStateToProps(state, ownProps) {
  return {
    branchId: state.branch.branch.item && state.branch.branch.item.id,
    hazards: state.hazards.hazardsByBranch.items,
    documents: state.settings.allDocuments.items,
    openDeleteDialog: state.hazards.deleteHazard.openDialog,
    hazardToBeDeleted: state.hazards.deleteHazard.hazard,
    errorMessage: state.hazards.deleteHazard.errorMessage,
    isDeletingHazard: state.hazards.deleteHazard.isSaving,
    selectedSortFilter: state.hazards.hazardDescriptionFilter.filter,
    loggedInUser: state.users.user.item
  };
}

function mapDispatchToProps(dispatch, ownProps) {
  return {
    fetchAllHazardsForBranch: (branchId) => {
      dispatch(fetchAllHazardsForBranchDispatch(branchId));
    },
    fetchAllDocuments: (branchId) => {
      dispatch(fetchAllDocumentsDispatch(documentType.DOCUMENT_LIBRARY, branchId));
    },
    handleHazardEditClick: (hazard, loggedInUserId) => {
      dispatch(openEditHazardDialogDispatch(true));
      dispatch(hazardEditClickDispatch(hazard));
      dispatch(
        fetchExistingAttachmentsForTheHazardDispatch(
          domainType.HAZARD,
          hazard.id,
          loggedInUserId
        )
      );
    },
    handleHazardControlEditClick: (hazard) => {
      dispatch(openEditHazardPanelDispatch(true));
      dispatch(hazardEditClickDispatch(hazard));
    },
    handleHazardReviewClick: (hazard) => {
      dispatch(openHazardReviewPanelDispatch(true));
      dispatch(hazardEditClickDispatch(hazard));
    },
    handleHazardManagementLogsClick: (hazard) => {
      dispatch(openHazardManagementLogPanelDispatch(true));
      dispatch(hazardEditClickDispatch(hazard));
    },
    openDeleteHazardDialog: (open, hazard) => {
      dispatch(openDeleteHazardDialogDispatch(open, hazard));
    },
    submitDeleteHazardRequest: (hazard) => {
      dispatch(submitDeleteHazardRequestDispatch(hazard));
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(HazardsList);
